(function () {
  function normalize(value) {
    return String(value || '')
      .replace(/\s+/g, ' ')
      .trim()
      .toLowerCase();
  }

  function cleanFileName(url) {
    if (!url) return '';

    var file = String(url).split('?')[0].split('/').pop();

    try {
      file = decodeURIComponent(file);
    } catch (e) {}

    return file.replace(/_(pico|icon|thumb|small|compact|medium|large|grande|master|\d+x\d+)(?=\.)/i, '');
  }

  function isBaseSize160230(variant) {
    var text = [
      variant.option1,
      variant.option2,
      variant.option3
    ].join(' ').replace(/\s+/g, '');

    return /160[*×xX]230/.test(text);
  }

  function getVariantImage(variant) {
    if (!variant) return null;

    var img = variant.featured_image || variant.image;

    if (!img) return null;

    return {
      id: img.id ? String(img.id) : null,
      src: img.src || img.url || null
    };
  }

  function getSelectedVariant(root, product) {
    var input =
      root.querySelector('form[action*="/cart/add"] [name="id"]') ||
      document.querySelector('form[action*="/cart/add"] [name="id"]');

    if (!input || !input.value) return null;

    return (product.variants || []).find(function (variant) {
      return String(variant.id) === String(input.value);
    }) || null;
  }

  function buildImageMap(product, imageOptionPosition) {
    var optionKey = 'option' + imageOptionPosition;
    var map = {};

    var variants = (product.variants || []).slice().sort(function (a, b) {
      return Number(isBaseSize160230(b)) - Number(isBaseSize160230(a));
    });

    variants.forEach(function (variant) {
      var optionValue = normalize(variant[optionKey]);
      var image = getVariantImage(variant);

      if (!optionValue || !image || !image.src) return;

      if (!map[optionValue]) {
        map[optionValue] = image;
      }
    });

    return map;
  }

  function clickElement(element) {
    if (!element) return false;

    var clickable =
      element.closest('button, a, [role="button"], .productView-thumbnail, .slick-slide') ||
      element.querySelector('button, a, [role="button"]') ||
      element;

    clickable.dispatchEvent(new MouseEvent('click', {
      bubbles: true,
      cancelable: true,
      view: window
    }));

    return true;
  }

  function tryClickThumbnail(root, targetImage) {
    if (!targetImage) return false;

    var selectors = [];

    if (targetImage.id) {
      selectors.push('[data-media-id*="' + targetImage.id + '"]');
      selectors.push('[data-image-id*="' + targetImage.id + '"]');
      selectors.push('[data-thumbnail-id*="' + targetImage.id + '"]');
      selectors.push('[data-target*="' + targetImage.id + '"]');
      selectors.push('[href="#' + targetImage.id + '"]');
    }

    for (var i = 0; i < selectors.length; i++) {
      var el = root.querySelector(selectors[i]) || document.querySelector(selectors[i]);

      if (el) {
        return clickElement(el);
      }
    }

    var targetFile = cleanFileName(targetImage.src);

    if (targetFile) {
      var imgs = root.querySelectorAll('img');

      for (var j = 0; j < imgs.length; j++) {
        var imgFile = cleanFileName(imgs[j].currentSrc || imgs[j].src);

        if (imgFile === targetFile) {
          return clickElement(imgs[j]);
        }
      }
    }

    return false;
  }

  function trySlickGoTo(root, targetImage) {
    if (!window.jQuery || !targetImage) return false;

    var $ = window.jQuery;
    var $root = root === document ? $(document.body) : $(root);
    var targetFile = cleanFileName(targetImage.src);

    var gallerySelectors = [
      '.productView-for.slick-initialized',
      '.productView-nav.slick-initialized',
      '.productView-images.slick-initialized',
      '.product-single__photos.slick-initialized',
      '.product__media-list.slick-initialized'
    ];

    for (var i = 0; i < gallerySelectors.length; i++) {
      var $gallery = $root.find(gallerySelectors[i]).first();

      if (!$gallery.length || typeof $gallery.slick !== 'function') continue;

      var $slide = $();

      if (targetImage.id) {
        $slide = $gallery
          .find('[data-media-id*="' + targetImage.id + '"], [data-image-id*="' + targetImage.id + '"]')
          .closest('.slick-slide:not(.slick-cloned)');
      }

      if (!$slide.length && targetFile) {
        $slide = $gallery.find('img').filter(function () {
          return cleanFileName(this.currentSrc || this.src) === targetFile;
        }).closest('.slick-slide:not(.slick-cloned)');
      }

      if ($slide.length) {
        var index = parseInt($slide.first().attr('data-slick-index'), 10);

        if (!isNaN(index)) {
          $gallery.slick('slickGoTo', index);
          return true;
        }
      }
    }

    return false;
  }

  function forceMainImage(root, targetImage) {
    if (!targetImage || !targetImage.src) return false;

    var selectors = [
      '.productView-image img',
      '.productView-for img',
      '.productView-img-container img',
      '.productView-media img',
      '.product-single__photo img',
      '.product__media img',
      '[data-main-product-image] img'
    ];

    var image = null;

    for (var i = 0; i < selectors.length; i++) {
      image = root.querySelector(selectors[i]);

      if (image) break;
    }

    if (!image) return false;

    image.removeAttribute('srcset');
    image.removeAttribute('data-srcset');
    image.removeAttribute('sizes');

    image.setAttribute('src', targetImage.src);

    var link = image.closest('a');

    if (link) {
      link.setAttribute('href', targetImage.src);
    }

    return true;
  }

  function initProductImageSwitcher(script) {
    var sectionId = script.id.replace('ShikimonoProductJson-', '');
    var config = window.ShikimonoProductImageConfig && window.ShikimonoProductImageConfig[sectionId];

    if (!config) return;

    var product;

    try {
      product = JSON.parse(script.textContent);
    } catch (e) {
      return;
    }

    var root =
      document.getElementById('shopify-section-' + sectionId) ||
      document.querySelector('[data-section-id="' + sectionId + '"]') ||
      document;

    var imageOptionPosition = config.imageOptionPosition || 2;
    var optionKey = 'option' + imageOptionPosition;
    var imageMap = buildImageMap(product, imageOptionPosition);

    function switchImage() {
      var selectedVariant = getSelectedVariant(root, product);

      if (!selectedVariant) return;

      var optionValue = normalize(selectedVariant[optionKey]);
      var targetImage = imageMap[optionValue];

      if (!targetImage) return;

      if (tryClickThumbnail(root, targetImage)) return;
      if (trySlickGoTo(root, targetImage)) return;

      forceMainImage(root, targetImage);
    }

    function scheduleSwitch() {
      [0, 80, 200, 500, 900].forEach(function (delay) {
        window.setTimeout(switchImage, delay);
      });
    }

    root.addEventListener('change', scheduleSwitch, true);

    root.addEventListener('click', function (event) {
      var target = event.target;

      if (
        target.closest('input') ||
        target.closest('select') ||
        target.closest('label') ||
        target.closest('[data-option-value]') ||
        target.closest('.swatch') ||
        target.closest('.product-form__input') ||
        target.closest('.variant-option') ||
        target.closest('.productView-options') ||
        target.closest('.product-form__radio') ||
        target.closest('.product-form__label')
      ) {
        scheduleSwitch();
      }
    }, true);

    document.addEventListener('variant:change', scheduleSwitch, true);
    document.addEventListener('product:variant-change', scheduleSwitch, true);
    document.addEventListener('halo:variant:change', scheduleSwitch, true);

    scheduleSwitch();
  }

  function initAll() {
    var scripts = document.querySelectorAll('script[id^="ShikimonoProductJson-"]');

    scripts.forEach(function (script) {
      if (script.dataset.shikimonoImageSwitcherLoaded === 'true') return;

      script.dataset.shikimonoImageSwitcherLoaded = 'true';
      initProductImageSwitcher(script);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  window.addEventListener('load', initAll);
  document.addEventListener('shopify:section:load', initAll);
})();